import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Card } from '@material-ui/core';
import { Modal } from 'antd';
import MainContainer from '../../../components/MainContainer';
import RoomTypeListPage from './RoomTypeList';
import RoomTypeModalPage from './RoomTypeModal';
import './RoomType.css';

@inject('RoomTypeStore')
@observer
class RoomTypePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    // ON CANCEL

    roomTypeModalOnCancel = () => {
        this.props.RoomTypeStore.setShowRoomTypeModal(false);
    }

    render() {
        const {
            showRoomTypeModal,
            roomTypeTitle,
        } = this.props.RoomTypeStore;

        return (
            <MainContainer title='Room Type' menukey='room-type'>
                <Modal
                    title={roomTypeTitle}
                    visible={showRoomTypeModal}
                    width={800}
                    footer={null}
                    onCancel={this.roomTypeModalOnCancel}
                    zIndex={1000}
                >
                    <RoomTypeModalPage />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <RoomTypeListPage />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default RoomTypePage;